const options = 'path=/; secure; samesite=lax; max-age=63072000';

export const setAuthCookies = (data) => {
  document.cookie = `token=${encodeURIComponent(data.token)}; ${options}`;
  document.cookie = `refreshToken=${encodeURIComponent(data.refresh_token)}; ${options}`;
  document.cookie = `expiresAt=${encodeURIComponent(data.expires_at)}; ${options}`;
};

export const setUserCookies = ({ email_address, id, name }) => {
  document.cookie = `USER_EMAIL=${email_address}; ${options}`;
  document.cookie = `USER_ID=${id}; ${options}`;
  document.cookie = `USER_NAME=${name}; ${options}`;
};

export const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp('(^|;\\s*)' + name + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[2]) : null;
};

export const clearAuthCookies = () => {
  const options = 'path=/; secure; samesite=lax; max-age=0'; // max-age=0 deletes cookie

  document.cookie = `token=; ${options}`;
  document.cookie = `refreshToken=; ${options}`;
  document.cookie = `expiresAt=; ${options}`;
};

export const clearUserCookies = () => {
  const options = 'path=/; secure; samesite=lax; max-age=0'; // max-age=0 deletes cookie

  document.cookie = `USER_EMAIL=; ${options}`;
  document.cookie = `USER_ID=; ${options}`;
  document.cookie = `USER_NAME=; ${options}`;
};
